import 'bootstrap-input-spinner'
import {VariantDict} from '../VariantDict'
import {notMaster} from '../filters'

export function initCartPage() {
	$('.cart').once('initCartPage').each(function () {
			const $cart = $(this)
			const $total = $cart.find('.cart__total')
			const $items = $cart.find('.cart__items')

			$items.find('.cart-item').once('Cart.item').each(function () {
				const $item = $(this)
				const $oos = $item.find('.cart-item__oos')
				const $img = $item.find('.cart-item__image img')
				const $quantityInput = $item.find('.cart-item__quantity input[name="updates[]"]')

				const currentQuantity = () => parseInt($quantityInput.val())
				const dict = new VariantDict($item.data('variantDict'))
				const item = cart.findItemWithVariant($item.data('variant'))
				const fallback = $item.data('fallbackImage')

				$item.find('.cart-item__option').each(function () {
					const $options = $(this)
					const $label = $options.find('.option__name')

					const idx = $options.data('optionIndex')
					const initialValue = '' + $options.data('optionInitialValue')
					dict.updateDefaultKey({[idx]: initialValue})

					$options.on('show.bs.dropdown show.bs.modal', function () {
						notMaster($options).find('.option__item').each(function () {
							const $option = $(this)
							dict.ifVariantExists({[idx]: $option.text()}, variant => {
								if (variant.available) {
									$option.removeClass('disabled')
								} else {
									$option.addClass('disabled')
								}
							})
						})
					})

					$options.find('.option__item').on('click', function (e) {
						const $option = $(this)
						const val = $option.text()
						updateCart(val)
						$options.find('.modal').modal('hide')
					})

					$options.find('.cart-item__option-select').on('change', function(e) {
						const $option = $(this)
						const val = $option.val()
						updateCart(val)
					})

					function updateCart(val) {
						dict.updateDefaultKey({[idx]: val})
						dict.ifVariantExists({[idx]: val}, function (nextVariant) {
							let imageSrc = fallback
							if (nextVariant.featured_image) {
								imageSrc = nextVariant.featured_image.src
							}
							$img.attr('src', imageSrc)
							if (nextVariant.available) {
								item.setVariant(nextVariant)
								$oos.hide()
							} else {
								$oos.show()
							}
							$label.text(val)
							$total.text(cart.getSubTotalAsMoneyString())
						}, () => {
							console.log('variant does not exist!')
						})
					}
				})


				let lastQuantity = currentQuantity()
				$quantityInput.on('change', function () {
					const quantity = currentQuantity()
					if (quantity === 0) {
						let didRemoveItem = false
						const $confirm = $('#remove-item-dialog')
						$confirm.find('.modal-title').text($item.data('removeItemMessage'))
						$confirm.one('hide.bs.modal', function () {
							if (didRemoveItem) {
								console.log('Removing item')
								item.setQuantity(0)
								$item.remove()
							} else {
								console.log('Not removing item')
								$quantityInput.val(lastQuantity)
							}
							$total.text(cart.getSubTotalAsMoneyString())
							lastQuantity = currentQuantity()
						})
						$confirm.find('.btn-yes').one('click', function () {
							didRemoveItem = true
						})
						$confirm.modal('show')
					} else {
						item.setQuantity(quantity)
						$total.text(cart.getSubTotalAsMoneyString())
					}
				})
			})

			// Cart item options should not be visible when JS is not running.
			$items.find('.cart-item__option').once('Cart.option').each(function () {
				const $option = $(this)
				$option.removeClass('js-not-yet')
			})

			$items.find('.cart-item__quantity').once('Cart.quantity').each(function () {
				const $quantity = $(this)
				$quantity.removeClass('js-fallback')
				$quantity.find('input').inputSpinner({
					incrementButton: '<span class="icon-plus"></span>',
					decrementButton: '<span class="icon-minus"></span>',
					groupClass: 'item-quantity',
					buttonsClass: 'item-quantity__button',
					buttonsWidth: '28px'
				})
			})

			$cart.find('.cart__update').addClass('js-not-needed')
		}
	)
}